import AuthenticPublisherEditionIcon from 'assets/Icons/OrangesLandingPage/AuthenticPublisherEdition'
import GenuineProductIcon from 'assets/Icons/OrangesLandingPage/GenuineProduct'
import React from 'react'

import RenderIf from '@/components/Common/RenderIf'

interface GenuineProductProps {
  isOrange?: boolean;
}

const GenuineProduct = ({ isOrange = false }: GenuineProductProps) => {

  return (
    <RenderIf condition={isOrange}>
      <div
        className='flex items-center gap-6 md:gap-[30px] py-4 md:px-5 rounded-lg'
      >
        {/* Genuine Product */}
        <div className='flex items-center gap-2.5'>
          <div
            className='flex items-center justify-center w-[42px] h-[42px] rounded-full flex-shrink-0'
            style={{ background: 'rgba(45, 213, 152, 0.15)' }}
          >
            <GenuineProductIcon />
          </div>
          <p className='text-white md:text-base text-[10px] font-semibold uppercase tracking-wide'>
            Genuine Product
          </p>
        </div>


        {/* Authentic Publisher Edition */}
        <div className='flex items-center gap-2.5'>
          <div
            className='flex items-center justify-center w-[42px] h-[42px] rounded-full flex-shrink-0'
            style={{ background: 'rgba(45, 213, 152, 0.15)' }}
          >
            <AuthenticPublisherEditionIcon />
          </div>
          <p className='text-white md:text-base text-[10px] font-semibold uppercase tracking-wide'>
            Authentic Publisher Edition
          </p>
        </div>
      </div>
    </RenderIf>
  )
}

export default GenuineProduct